import type {
  PublicOrderResponse,
  PublicUserResponse,
} from '@contracts/order/PublicOrderResponse';
import { Client } from '@src/common/services/Client';
import {
  PublicOrderErrorCode,
  type PublicOrderResult,
  PublicOrderResultType,
} from '@src/publicPortal/PublicOrderResult';
import axios from 'axios';

interface BackendErrorBody {
  error: PublicOrderErrorCode;
  data?: { claimedBy?: PublicUserResponse };
}

export const PublicOrderClient = {
  getByToken: async (token: string): Promise<PublicOrderResult> => {
    try {
      const { data } = await Client.get<PublicOrderResponse>(
        `public/orders/${token}`,
      );
      return { type: PublicOrderResultType.OK, order: data };
    } catch (error) {
      const expired = tryParseExpired(error);
      if (expired) return expired;
      throw error;
    }
  },
};

const tryParseExpired = (error: unknown): PublicOrderResult | undefined => {
  if (!axios.isAxiosError<BackendErrorBody>(error)) return;
  const body = error.response?.data;
  if (body?.error !== PublicOrderErrorCode.ACCESS_EXPIRED) return;
  return {
    type: PublicOrderResultType.EXPIRED,
    claimedBy: body.data?.claimedBy,
  };
};
